var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"barra-izquierda-contenido-mini"},[_c('div',{staticClass:"w-100 text-center px-1"},[_c('v-btn',{attrs:{"block":"","color":"primary"},on:{"click":_vm.Crear}},[_c('code',{staticClass:"mr-1"},[_vm._v("F5")]),_vm._v(" Crear nuevo")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }